
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 14 13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.067 9.47l4.7-4.552-.933-.904-3.767 3.649-1.9-1.841-.933.904 2.833 2.745zM7 12.959c-.922 0-1.789-.17-2.6-.508a6.748 6.748 0 01-2.117-1.38A6.515 6.515 0 01.859 9.018 6.12 6.12 0 01.333 6.5c0-.893.175-1.733.525-2.519.35-.785.826-1.469 1.425-2.05A6.749 6.749 0 014.4.55 6.673 6.673 0 017 .04c.922 0 1.789.17 2.6.51.811.338 1.517.799 2.117 1.38a6.515 6.515 0 011.425 2.05 6.12 6.12 0 01.525 2.52 6.12 6.12 0 01-.525 2.518 6.515 6.515 0 01-1.425 2.05A6.748 6.748 0 019.6 12.45a6.672 6.672 0 01-2.6.51z"}})])
          )
        }
      }
    